import { useGetters } from './getters';
import { useMutations } from './mutations';
import { useState } from './state';

/**
 * Date formatting utilities
 */
const formatToDb = (dateObj) => {
    return dateObj.getFullYear() + '-' + String(dateObj.getMonth() + 1).padStart(2, '0') + '-' + dateObj.getDate();
};

const formatDateFromStr = (datestr) => {
    let dateObj = new Date(datestr);
    return dateObj.getFullYear() + '-' + String(dateObj.getMonth() + 1).padStart(2, '0') + '-' + dateObj.getDate();
};

const formatDateWithZeroFromStr = (datestr) => {
    var isFirefox = typeof InstallTrigger !== 'undefined';
    let userAgentString = navigator.userAgent;
    var isChrome = userAgentString.indexOf('Chrome') > -1;
    let isSafari = userAgentString.indexOf('Safari') > -1;

    if (isFirefox || isChrome) {
        let dateObj = new Date(datestr);
        return dateObj.getFullYear() + '-' + String(dateObj.getMonth() + 1).padStart(2, '0') + '-' + String(dateObj.getDate()).padStart(2, '0');
    }
    if (isSafari) {
        let actualDate = datestr.split(' ');
        let dateStrArr = actualDate[0].split('-');
        let yy = parseInt(dateStrArr[0]);
        let mm = parseInt(dateStrArr[1]);
        let dd = parseInt(dateStrArr[2]);
        mm = String(mm).padStart(2, '0');
        dd = String(dd).padStart(2, '0');
        let datWithTime = yy + '-' + mm + '-' + dd + 'T00:00:00';
        let dateObj = new Date(datWithTime);
        return dateObj.getFullYear() + '-' + String(dateObj.getMonth() + 1).padStart(2, '0') + '-' + String(dateObj.getDate()).padStart(2, '0');
    } else {
        let actualDate = datestr.split(' ');
        let dateStrArr = actualDate[0].split('-');
        let yy = parseInt(dateStrArr[0]);
        let mm = parseInt(dateStrArr[1]);
        let dd = parseInt(dateStrArr[2]);
        let dateObj = new Date(yy, mm, dd, 0, 0, 0);
        return dateObj.getFullYear() + '-' + String(dateObj.getMonth()).padStart(2, '0') + '-' + String(dateObj.getDate()).padStart(2, '0');
    }
};

const formatDateWithDash = (dateStr) => {
    let dateObj = new Date(dateStr);
    return String(dateObj.getMonth() + 1).padStart(2, '0') + '-' + dateObj.getDate() + '-' + dateObj.getFullYear();
};

const formatDateWithDashNew = (dateStr) => {
    dateStr = appendTimeForBrowser(dateStr);
    let dateObj = new Date(dateStr);
    return String(dateObj.getMonth() + 1).padStart(2, '0') + '-' + dateObj.getDate() + '-' + dateObj.getFullYear();
};

const formatDate = (dateStr) => {
    let dateObj = new Date(dateStr);
    return String(dateObj.getMonth() + 1).padStart(2, '0') + '/' + dateObj.getDate() + '/' + dateObj.getFullYear();
};

const formatDateWithPaddedZeros = (dateStr) => {
    if (!dateStr) {
        return '';
    }
    
    // Handle if dateStr is already a Date object
    let dateObj;
    if (dateStr instanceof Date) {
        dateObj = dateStr;
    } else {
        // Try different parsing strategies for cross-browser compatibility
        let userAgentString = navigator.userAgent;
        let isSafari = userAgentString.indexOf('Safari') > -1 && userAgentString.indexOf('Chrome') === -1;
        
        if (isSafari && typeof dateStr === 'string') {
            // Safari needs ISO format dates
            if (dateStr.indexOf('T') === -1 && dateStr.indexOf(' ') > -1) {
                // Convert "YYYY-MM-DD HH:mm:ss" to "YYYY-MM-DDTHH:mm:ss"
                dateStr = dateStr.replace(' ', 'T');
            } else if (dateStr.indexOf('T') === -1 && dateStr.indexOf(' ') === -1) {
                // Add time if missing
                dateStr = dateStr + 'T00:00:00';
            }
        }
        
        dateObj = new Date(dateStr);
    }
    
    // Validate the date object
    if (isNaN(dateObj.getFullYear()) || isNaN(dateObj.getMonth()) || isNaN(dateObj.getDate())) {
        console.warn('formatDateWithPaddedZeros: Invalid date:', dateStr);
        return '';
    }
    
    return String(dateObj.getMonth() + 1).padStart(2, '0') + '-' + String(dateObj.getDate()).padStart(2, '0') + '-' + dateObj.getFullYear();
};

const appendTime = (date) => {
    if (!date) {
        return date;
    }
    
    // If it's already a Date object, convert to string first
    if (date instanceof Date) {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        date = `${year}-${month}-${day}`;
    }
    
    // Ensure date is a string
    date = String(date);
    
    return date.split(' ').length > 1 ? date : `${date} 00:00:00`;
};

const appendTimeForBrowser = (date) => {
    if (!date) {
        return date;
    }
    
    // If it's already a Date object, convert to ISO string first
    if (date instanceof Date) {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        date = `${year}-${month}-${day}`;
    }
    
    // Ensure date is a string
    date = String(date);
    
    // Check if time is already appended
    if (date.indexOf('00:00:00') < 0 && date.indexOf('T00:00:00') < 0) {
        let userAgentString = navigator.userAgent;
        let isSafari = userAgentString.indexOf('Safari') > -1 && userAgentString.indexOf('Chrome') === -1;

        if (isSafari) {
            return `${date}T00:00:00`;
        } else {
            return `${date} 00:00:00`;
        }
    }

    return date;
};

/**
 * Product utilities
 */
const getDefaultImage = (productType) => {
    let images = localStorage.getItem('productTypes');
    images = JSON.parse(images);
    if (productType == '' || productType == null) {
        return '';
    }
    for (var i = 0; i < images.length; i++) {
        if (images[i]['id'] == productType) return images[i]['default_image'];
    }

    return '';
};

const getMaxQuantity = (product) => {
    if (product.order_max_quantity > 0 && product.order_max_quantity < product.qty) {
        return product.order_max_quantity;
    }
    return product.qty;
};

/**
 * Cart utilities
 */
const clearCartComments = () => {
    let allCurrentCarts = JSON.parse(localStorage.getItem('cart'));
    let exceptCart = [];
    for (const progId in allCurrentCarts) {
        exceptCart.push(parseInt(progId));
    }
    let site_settings = JSON.parse(localStorage.getItem('site_settings'));

    let cartsType = [
        parseInt(site_settings.miami_direct_boxlots_id),
        parseInt(site_settings.live_local_id),
        parseInt(site_settings.dutch_direct_boxlots_id),
        parseInt(site_settings.farm_direct_boxlots_id),
        parseInt(site_settings.flower_futures_id),
        parseInt(site_settings.hardgoods_id),
        parseInt(site_settings.mass_markets_id),
        parseInt(site_settings.weekly_specials_id),
    ];
    let difference = [];
    if (exceptCart.length > 0) {
        difference = cartsType.filter((x) => !exceptCart.includes(x)).concat(exceptCart.filter((x) => !cartsType.includes(x)));
    } else {
        difference = cartsType;
    }

    let cartsCommentExists = '';
    difference.forEach((cartId) => {
        cartsCommentExists = localStorage.getItem('cartCommentsDetails_' + cartId);
        if (cartsCommentExists) localStorage.removeItem('cartCommentsDetails_' + cartId);

        cartsCommentExists = localStorage.getItem('cartPoDetails_' + cartId);
        if (cartsCommentExists) localStorage.removeItem('cartPoDetails_' + cartId);
    });
};

/**
 * Composable for miscellaneous utility functions using Composition API
 * @returns {Object} Utility methods and Vuex state/getters/actions
 */
export function useMisc() {
    const { isLoggedIn } = useGetters();
    const { addToWL } = useMutations();
    const { wl } = useState();

    /**
     * Try to add product to wishlist
     */
    const tryAddToWL = (prodId) => {
        if (!isLoggedIn.value) {
            return 0;
        }

        if (prodId in wl.value) {
            return -1;
        }

        addToWL(prodId);
        return 1;
    };

    return {
        tryAddToWL,
        formatToDb,
        formatDateFromStr,
        formatDateWithZeroFromStr,
        formatDateWithDash,
        formatDateWithDashNew,
        formatDate,
        formatDateWithPaddedZeros,
        appendTime,
        appendTimeForBrowser,
        getDefaultImage,
        getMaxQuantity,
        clearCartComments
    };
}

// Legacy mixin export for backward compatibility
export default {
    computed: {
        isLoggedIn() {
            return this.$store.getters.isLoggedIn;
        }
    },
    data() {
        return {
            wl: this.$store.state.wl,
        }
    },
    methods: {
        addToWL(prodId) {
            this.$store.commit('addToWL', prodId);
        },
        tryAddToWL(prodId) {
            if (!this.isLoggedIn) {
                return 0;
            }

            if (prodId in this.wl) {
                return -1;
            }

            this.addToWL(prodId);
            return 1;
        },
        formatToDb(dateObj) {
            return formatToDb(dateObj);
        },
        formatDateFromStr(datestr) {
            return formatDateFromStr(datestr);
        },
        formatDateWithZeroFromStr(datestr) {
            return formatDateWithZeroFromStr(datestr);
        },
        formatDateWithDash(dateStr) {
            return formatDateWithDash(dateStr);
        },
        formatDateWithDashNew(dateStr) {
            return formatDateWithDashNew(dateStr);
        },
        formatDate(dateStr) {
            return formatDate(dateStr);
        },
        formatDateWithPaddedZeros(dateStr) {
            return formatDateWithPaddedZeros(dateStr);
        },
        appendTime(date) {
            return appendTime(date);
        },
        appendTimeForBrowser(date) {
            return appendTimeForBrowser(date);
        },
        getDefaultImage(productType) {
            return getDefaultImage(productType);
        },
        clearCartComments() {
            clearCartComments();
        },
        getMaxQuantity(product) {
            return getMaxQuantity(product);
        },
    },
};

